<div
  [ngClass]="{ inline: isInline, readOnly: !canEdit && !isNew }"
  class="fullModal opened"
  id="ZitiAdvancedServiceConfigAddModal"
  >
  <div [hidden]="isComplete" class="fullRow">
    <div class="title" style="filter: brightness(50%)">
      @if (!isEditing) {
        <span>Create A New Service</span>
      }
      @if (isEditing) {
        <span>Edit Your Service</span>
      }
    </div>
    @if (!isEditing) {
      <div class="subtitle">Enter your service details</div>
    }
    @if (isEditing) {
      <div class="subtitle">Edit your service details</div>
    }
    <div
      class="subhelp"
      matTooltip="A service defines how connections are created for applications. Services are a fundamental building block of a NetFoundry overlay network."
      matTooltipPosition="below"
      >
      What's a Service?
      <div class="infoicon"></div>
    </div>
    <div class="sized full">
      <div class="grid two">
        <div>
          <div class="label row">SERVICE DETAILS</div>
          <div class="service-details-container">
            <app-text-property-editor
              (focusOut)="validateName()"
              (modelChange)="nameChanged()"
              [(model)]="model"
              [disabled]="isEditing && !canEdit"
              [errors]="errors['name']"
              [label]="'Service Name'"
              [maxLength]="'64'"
              [minLength]="'5'"
              [placeholder]="'Name this service'"
              [propertyName]="'name'"
              [required]="true"
            ></app-text-property-editor>
            <div class="label row">
              Service Attributes
              <div
                class="infoicon"
                matTooltip="Service Attributes are tags applied to a service. Apply the same tag to other services to form a group of services."
                matTooltipPosition="below"
              ></div>
              <span class="note">Optional</span>
            </div>
            <div class="row">
              <app-tags-selector
                (addAttribute)="addServiceAttribute($event)"
                (removeAttribute)="removeServiceAttribute($event)"
                [availableAttributes]="serviceAttributes"
                [disableField]="isEditing && !canEdit"
                [hasError]="svcError"
                [isLoading]="isLoadingSvcAttr"
                [placeholder]="'Add attributes to group services'"
                [selectedAttributes]="selectedServiceAttributes"
                id="Service"
              ></app-tags-selector>
            </div>
            <app-toggle-property-editor
              [(model)]="model"
              [description]="'ENCRYPT THIS SERVICE'"
              [disabled]="disableEncryptionToggle"
              [errors]="errors['encryptionRequired']"
              [label]="'End-to-End Encryption'"
              [ngClass]="{ disabled: disableEncryptionToggle }"
              [propertyName]="'encryptionRequired'"
              [required]="false"
                            [toolTip]="
                                !model.modelType
                                    ? 'Encryption must be enabled for advanced configurations'
                                    : isEditing
                                    ? 'Encryption can\'t be changed once service has been created'
                                    : 'Encrypts packets when entering or leaving the network.'
                            "
              class="encryptionToggle"
            ></app-toggle-property-editor>
          </div>
          <div class="label row">SERVICE BIND POLICY</div>
          <div class="service-details-container">
            <div class="label row">
              SELECT HOSTS FOR THIS SERVICE
              <div
                class="infoicon"
                matTooltip="Endpoint Attributes are tags applied to a service. Apply the same tag to other endpoints to form a group of services."
                matTooltipPosition="below"
              ></div>
              <span class="note">Optional</span>
            </div>
            <div class="row">
              <app-tags-selector
                (addAttribute)="addEndpointsAttributes($event)"
                (removeAttribute)="removeEndpointAttribute($event)"
                [availableAttributes]="endpointAttributes"
                [disableField]="isEditing && !canEdit"
                [hasError]="endpointAttributeError"
                [isLoading]="isLoadingEndpointAttr"
                [placeholder]="'Choose the endpoints to associate to this Service'"
                [selectedAttributes]="selectedEndpointAttributes"
                id="Service"
              ></app-tags-selector>
            </div>
          </div>
          <div class="label row">Service Edge Router Policy</div>
          <div class="service-details-container">
            <div class="label row">
              Edge Router Attributes
              <div
                class="infoicon"
                matTooltip="Service Attributes are tags applied to a service. Apply the same tag to other services to form a group of services."
                matTooltipPosition="below"
              ></div>
              <span class="note">Optional</span>
            </div>
            <div class="row">
              <app-tags-selector
                (addAttribute)="addEdgeRouterAttribute($event)"
                (removeAttribute)="removeEdgeRouterAttribute($event)"
                [availableAttributes]="edgeRouterAttributes"
                [disableField]="isEditing && !canEdit"
                [hasError]="edgeRouterError"
                [isLoading]="isLoadingEdgeRouterAttr"
                [placeholder]="'Default: #all, restricts routers available to this service'"
                [selectedAttributes]="selectedEdgeRouterAttributes"
                id="Router"
              ></app-tags-selector>
            </div>
          </div>

          @if (isEditing) {
            <div class="associated row">
              <app-preview-list
                (itemSelected)="endpointSelected($event)"
                [allNames]="assocEndpointNames"
                [clickable]="!isInline"
                label="Associated Endpoints"
              ></app-preview-list>
              @if (featureService.powerUserEnabled) {
                <app-preview-list
                  (itemSelected)="routerSelected($event)"
                  [allNames]="assocRouterNames"
                  [clickable]="!isInline"
                  label="Associated Edge Routers"
                ></app-preview-list>
              }
            </div>
          }
        </div>
        <div>
          <div class="label row">
            Service Configuration
            <div
              class="infoicon"
              matTooltip="Protocol IP/Hostname and port of destination application. Note: Must be reachable from assigned endpoint/host."
              matTooltipPosition="below"
            ></div>
            <span class="note">OPTIONAL</span>
          </div>
          @for (addedConfig of addedConfigs; track addedConfig; let i = $index) {
            <div class="darkBox configBox">
              <div class="row mini-pod">
                <div class="label row" style="margin-bottom: 0rem">SELECT CONFIGURATION</div>
                <select
                  (change)="configTypeChanged(addedConfig)"
                  [(ngModel)]="addedConfig.selectedConfigTypeId"
                  [disabled]="isEditing && !addedConfig.isNew"
                  [ngClass]="{ error: configErrors.configType }"
                  class="service-config-select"
                  id="ServiceConfigTypes"
                  >
                  <option [ngValue]="undefined">Select a Config Type</option>
                  @for (configType of configTypes; track configType) {
                    <option
                      [hidden]="configType.hidden && configType.id !== addedConfig.type.id"
                      [value]="configType.id"
                      >
                      {{ configType.name }}
                    </option>
                  }
                </select>
                <select
                  (change)="configChanged(addedConfig)"
                  [(ngModel)]="addedConfig.selectedConfigId"
                  [disabled]="!addedConfig.selectedConfigTypeId || (isEditing && !addedConfig.isNew)"
                  [ngClass]="{ error: configErrors.config }"
                  class="service-config-select"
                  id="ServiceConfigs"
                  >
                  <option [ngValue]="undefined">Select a Config Or Add New</option>
                  <option [value]="'new_config'">NEW CONFIG</option>
                  @for (displayConfig of addedConfig.displayConfigs; track displayConfig) {
                    <option
                      [value]="displayConfig.id"
                      >
                      {{ displayConfig.name }}
                    </option>
                  }
                </select>
              </div>
              @if (addedConfig.selectedConfigTypeId && addedConfig.selectedConfigId) {
                <div>
                  <div class="row mini-pod">
                    <div class="label row">CONFIG NAME</div>
                    <input
                      (keyup.enter)="save()"
                      [(ngModel)]="addedConfig.name"
                      [disabled]="isEditing && !addedConfig.isNew"
                                    [ngClass]="{
                                        error:
                                            errors.configs[addedConfig.id] &&
                                            errors.configs[addedConfig.id]['nameInvalid']
                                    }"
                      id="EditConfigName"
                      maxlength="64"
                      minlength="5"
                      placeholder="Configuration Name"
                      type="text"
                      />
                  </div>
                </div>
              }
              @if (true) {
                <div>
                  <div class="viewgrid">
                    @if (featureService.experimentalFeatures) {
                      <div
                        (click)="toggleJsonView()"
                        [ngClass]="{ on: isFormView }"
                        class="jsonView"
                        >
                        JSON VIEW
                      </div>
                    }
                    @if (featureService.experimentalFeatures) {
                      <div
                        (click)="toggleJsonView()"
                        [ngClass]="{ on: isFormView }"
                        class="toggle"
                        >
                        @if (featureService.experimentalFeatures) {
                          <div class="switch"></div>
                        }
                      </div>
                    }
                    @if (featureService.experimentalFeatures) {
                      <div
                        (click)="toggleJsonView()"
                        class="formView"
                        >
                        FORM VIEW
                      </div>
                    }
                  </div>
                  @if (!isFormView) {
                    <div
                      [ngClass]="{ error: addedConfig.invalid, readOnly: isEditing && !addedConfig.isNew }"
                      class="row"
                      style="border-radius: var(--inputBorderRadius)"
                      >
                      <app-json-view
                        #editor
                        [(data)]="addedConfig.data"
                        [(jsonInvalid)]="addedConfig.invalid"
                        [readOnly]="!canEdit"
                        ngDefaultControl
                      ></app-json-view>
                    </div>
                  }
                  @if (isFormView && featureService.experimentalFeatures) {
                    <div>
                      <app-tab-creator
                        (selectTab)="selectActiveTab($event)"
                        [activeTitle]="activeTitle"
                        [titles]="titles"
                      ></app-tab-creator>
                      @if (activeTitle === 'Options') {
                        <app-host-v1-options
                          [errors]="errors"
                          [isEditing]="isEditing"
                          [isNew]="isNew"
                          [model]="addedConfig"
                          [readOnly]="!canEdit"
                        ></app-host-v1-options>
                      }
                    </div>
                  }
                  <button (click)="removeServiceConfig(i)" class="remove">
                    <div class="icon-HamburgerAppClose"></div>
                  </button>
                </div>
              }
            </div>
          }
          <div class="darkBox pb16">
            <button (click)="addServiceConfig()" class="save another mb0">ADD SERVICE CONFIGURATION</button>
          </div>
        </div>
      </div>

      @if (!isEditing || canEdit) {
        <div class="row buttonRow right" style="margin-top: 1.25rem">
          @if (!processing && !isLoading) {
            <button (click)="save()" class="save" id="SaveServiceZitiButton">
              {{ bulkEdit ? 'Done' : isEditing ? 'Update' : 'Create' }}
            </button>
          }
          @if (isLoading || processing) {
            <button class="save confirm" disabled>
              {{ isLoading ? 'Loading' : 'Saving' }}
              <span class="spinner"></span>
            </button>
          }
        </div>
      }
    </div>
    @if (isEditing) {
      <div (click)="getMetrics()" class="buttonBall metrics" id="MetricsButton">
        <div class="buttonLabel">METRICS</div>
      </div>
    }
    @if (isEditing) {
      <div (click)="getDialLogs()" class="buttonBall network-failure" id="DialLogsButton">
        <div class="buttonLabel">Dial Logs</div>
      </div>
    }

    <div (click)="hide()" class="buttonBall close" id="EscZitiServiceClose">
      <div class="buttonLabel">ESC</div>
    </div>
    @if (!hideHelp) {
      <app-form-support-button></app-form-support-button>
    }
  </div>
</div>
